import { camelCaseToWords } from '../../utils/camelCaseToWords.ts';
import { type ExportFileField } from '../ExportFileTypes.ts';

export function useExportFileFieldSelectOptions(
  fields: ExportFileField[] | null | undefined,
) {
  if (!fields) {
    return [];
  }
  return fields
    .map(field => ({
      value: field.id!,
      label: field.titolo ?? camelCaseToWords(field.chiave!) ?? '',
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
}
